export const licenseKey =
  'ewogICJmb3JtYXQiOiAxLAogICJjdXN0b21lcklkIjogIjE5MTM5NDFiLTBkMmUtNGQ4Mi04MmUyLTA2MzNmMjAyZjE5NCIsCiAgIm1heFZlcnNpb25BbGxvd2VkIjogMjUxCn0=.kumsXQVNdYtrr1DczQJXNvk71h53rM3yP5kUY2TL2rxZiEIK47dR6QLQj0PrqHbB4LfXxqYBRjzfxaVFpuNgXUsh/WhehVNoPMnbL1t9xfHOOw/YGZq82lyAx1j2GH266OQzZA==';
